import * as React from 'react';

interface Props {
    children?: React.ReactElement | React.ReactElement[]
}

const Margin:React.FC<Props> = (props) => {
    return ( 
        <div style={{margin: '20px 0'}}>
            {props.children}
        </div>
     );
}
 
export default Margin;